import serverContext from '../serverContext';
import { heapTrackEvent } from '@shared_modules/baui-heap-tracking';

const withCommonTrackingAttributes = (trackingPayload = {}) => {
  if (!serverContext.cleanSweepHeapTrackingAttr) return trackingPayload;

  const { AID, CAMPAIGN, MEDIUM, PROD_ID, REFERRER_ID, TOKEN, LOAN_ID } = serverContext.cleanSweepHeapTrackingAttr;
  const commonCleanSweepTrackingAttr = {
    AID,
    CAMPAIGN,
    MEDIUM,
    PROD_ID,
    REFERRER_ID,
    TOKEN,
    LOAN_ID,
  };
  return Object.assign(trackingPayload, commonCleanSweepTrackingAttr);
};

const trackLoginFailureAttributes = (data = {}) => {
  const { name, status, message } = data;
  const trackingPayload = withCommonTrackingAttributes({
    ERROR_KEYS: name,
    ERROR_STATUS: status,
    ERROR_MESSAGES: message,
  });
  heapTrackEvent('Origination_CleanSweep_SignIn_Failure', trackingPayload);
};

const trackCleanSweepView = (eventName = 'Origination_ILOC_LandingPage_CleanSweepView', additionalAttributes) => {
  const { cleanSweepHeapTrackingAttr } = serverContext;

  if (cleanSweepHeapTrackingAttr) heapTrackEvent(eventName, { ...cleanSweepHeapTrackingAttr, ...additionalAttributes });
};

export { withCommonTrackingAttributes, trackLoginFailureAttributes, trackCleanSweepView };

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/iloc/iloc.scss');